import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SPORTS } from "@/lib/content";

const NEWS_SPORTS = ["football", "basketball", "hockey", "boxing", "mma"];
import NewsCard from "@/components/NewsCard";
import { Newspaper } from "lucide-react";

export default function NewsPage() {
  const [news, setNews] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const params = filter === "all" ? {} : { sport: filter };
    api.get("/news", { params }).then((r) => setNews(r.data || [])).catch(() => {});
  }, [filter]);

  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-6 py-12">
      <div className="text-xs font-bold tracking-[0.2em] text-smasher-orange mb-1">FROM THE SMASHER DESK</div>
      <h1 className="font-heading font-black uppercase text-4xl sm:text-5xl text-gradient-gold flex items-center gap-3 mb-2"><Newspaper className="w-9 h-9 text-smasher-gold" /> Latest Sports News</h1>
      <p className="text-slate-400 mb-6 max-w-2xl">Quick-hit betting news and market breakdowns, summarized by the Sportsbook Smasher team so you can read the game before you make the wager.</p>

      <div className="flex flex-wrap gap-2 mb-8 no-scrollbar">
        <button onClick={() => setFilter("all")} className={`px-4 py-2 rounded-full text-sm font-bold transition ${filter === "all" ? "btn-gold" : "btn-ghost-gold"}`} data-testid="news-filter-all">ALL</button>
        {SPORTS.filter((s) => NEWS_SPORTS.includes(s.key)).map((s) => (
          <button key={s.key} onClick={() => setFilter(s.key)} className={`px-4 py-2 rounded-full text-sm font-bold transition ${filter === s.key ? "btn-gold" : "btn-ghost-gold"}`} data-testid={`news-filter-${s.key}`}>
            {s.label.toUpperCase()}
          </button>
        ))}
      </div>

      {news.length ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{news.map((n) => <NewsCard key={n.id} item={n} />)}</div>
      ) : (
        <div className="panel p-10 text-center text-slate-500" data-testid="news-empty">No news available for this category right now.</div>
      )}
    </div>
  );
}
